<div style="width: 100vw; height: 100vh">
    <pdf-preview [pathPdf]="url+'#view=FitH'" style="position: relative"></pdf-preview>
</div>